<template>
    <div class="page">
        <div class="baner-subpage">
            <div class="container">
                <div class="text">Judaszowce, lecz nie tylko ...</div>
            </div>
        </div>
        <div class="content">
            <div class="container">
                <h2 class="pageHeader text-center">
                    Asortyment
                </h2>
                <div class="cms text-center">
                    Aktualny cennik hurtowy wysyłamy na zapytanie. <br/>
                    Please, ask for our current price list.
                    <br/><br/><br/>
                </div>

            </div>
        </div>
        <div class="asortyment">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-md-4 item">
                        <b>DRZEWA W POJEMNIKACH - TREES IN CONTAINERS</b><br/>
                        <br/>
                        <em>Acer campestre</em><br/>
                        <span>ELSRIJK</span><br/>
                        <span>NANUM</span><br/>
                        <br/>
                        <em>Acer platanoides</em><br/>
                        <span>COLUMNARE</span><br/>
                        <span>CRIMSON KING</span><br/>
                        <span>CRIMSON SENTRY</span><br/>
                        <span>DRUMMONDII</span><br/>
                        <span>GLOBOSUM</span><br/>
                        <span>ROYAL RED</span><br/>
                        <br/>
                        <em>Aesculus carnea</em><br/>
                        <span>BRIOTII</span><br/>
                        <br/>
                        <em>Carpinus betulus</em><br/>
                        <span>FASTIGIATA</span><br/>
                        <span>LUCAS</span><br/>
                        <span>ENDULA</span><br/>
                        <br/>
                        <em>Catalpa bignonioides</em><br/>
                        <span>AUREA</span><br/>
                        <span>NANA(dostępna również z gołym korzeniem)</span><br/>
                        <br/>
                        <em>Fagus sylvatica</em><br/>
                        <span>ATROPUNICA</span><br/>
                        <span>BLACK SWANN</span><br/>
                        <span>DAWYCK</span><br/>
                        <span>DAWYCK GOLD</span><br/>
                        <span>DAWYCK PURPLE</span><br/>
                        <span>PURPLE FOUNTAIN</span><br/>
                        <span>PURPUREA PENDULA</span><br/>
                        <span>ROHAN OBELISK</span><br/>
                        <span>ROLPH MARQUARD</span><br/>
                        <span>SPEATHIANA</span><br/>
                        <span>TRICOLOR</span><br/>
                        <br/>
                        <em>Ginkgo biloba</em><br/>
                        <span>GLOBUS</span><br/>
                        <span>MARIKEN</span><br/>
                        <span>MENHIR</span><br/>
                        <br/>
                        <em>Gleditschia triacanthos</em><br/>
                        <span>SUNBURST</span><br/>
                        <br/>
                        <em>Liriodendron tulipifera</em><br/>
                        <span>FASTIGIATA</span><br/>
                        <br/>
                        <em>Liquidambar styraciflua</em><br/>
                        <span>GUMBALL</span><br/>
                        <span>SLENDER SILHOUETTE</span><br/>
                        <span>WORPLESDON</span><br/>
                        <br/>
                        <em>Morus alba</em><br/>
                        <span>PENDULA</span><br/>
                        <br/>
                        <em>Platanus acerifolia</em><br/>
                        <span>ALPHENS GLOBE</span><br/>
                        <br/>
                        <em>Prunus cerasifera</em><br/>
                        <span>NIGRA</span><br/>
                        <br/>
                        <em>Prunus eminens</em><br/>
                        <span>UMBRACULIFERA</span><br/>
                        <br/>
                        <em>Prunus serrulata</em><br/>
                        <span>AMANOGAWA</span><br/>
                        <span>KANZAN</span><br/>
                        <span>ROYAL BURGUNDY</span><br/>
                        <br/>
                        <em>Quercus palustris</em><br/>
                        <span>GREEN DWARF</span><br/>
                        <span>GREEN PILLAR</span><br/>
                        <br/>
                        <em>Robinia pseudoacacia</em><br/>
                        <span>UMBRACULIFERA</span><br/>
                        <br/>
                        <em>Sophora japonica</em><br/>
                        <span>PENDULA</span><br/>
                        <br/>
                        <em>Sorbus aucuparia</em><br/>
                        <span>AUTUMN SPIRE</span><br/>
                        <span>FINGERPRINT</span><br/>
                        <br/>
                        <em>Ulmus glabra</em><br/>
                        <span>CAMPERDOWNII</span><br/>
                        <br/>
                        <em>Ulmus hollandica</em><br/>
                        <span>WREDEI</span><br/>

                    </div>
                    <div class="col-12 col-md-4 item">
                        <b>KRZEWY LIŚCIASTE - DECIDUOUS SCHRUBS</b><br/>
                        <br/>
                        <em>Berberis thunbergii</em><br/>
                        <span>ADMIRATION</span><br/>
                        <span>AUREA</span><br/>
                        <span>CONCORDIA</span><br/>
                        <span>ORANGE ROCKET</span><br/>
                        <span>TINY GOLD</span><br/>
                        <br/>
                        <em>Cotinus coggyria</em>   <br/>
                        <span>GOLDEN SPIRIT</span><br/>
                        <span>ROYAL PURPLE</span><br/>
                        <br/>
                        <em>Hibiscus syriacus</em><br/>
                        <span>HAMABO</span><br/>
                        <span>MARINA</span><br/>
                        <span>WOODBRIDGE</span><br/>
                        <span>BLUE CHIFFON</span><br/>
                        <span>LAVENDER CHIFFON</span><br/>
                        <span>MAGENDA CHIFFON</span><br/>
                        <span>PINK CHIFFON</span><br/>
                        <span>WHITE CHIFFON</span><br/>
                        <span>PURPLE PILLAR</span><br/>
                        <br/>
                        <em>Hydrangea paniculata</em>   <br/>
                        <span>BOBO</span><br/>
                        <span>CANDLELIGHT</span><br/>
                        <span>LIMELIGHT</span><br/>
                        <span>PINKY WINKY</span><br/>
                        <span>POLAR BEAR</span><br/>
                        <span>VANILLE FRAISE</span><br/>
                        <br/>
                        <em>Hydrangea anomala</em><br/>
                        <span>PETIOLARIS</span><br/>
                        <br/>
                        <em>Lavendula angustifolia</em><br/>
                        <span>HIDCOTE</span><br/>
                        <br/>
                        <em>Sambucus nigra</em><br/>
                        <span>BLACK LACE</span><br/>
                        <br/>
                        <em>Spirea japonica </em><br/>
                        <span>GOLDEN PRINCESS</span>


                    </div>
                    <div class="col-12 col-md-4 item">
                        <b>PNĄCZA - CREEPERS</b><br/>
                        <br/>
                        <em>Campsis</em><br/>
                        <span>INDIAN SUMMER   na "pniu"  - on stam 80cm</span><br/>
                        <span>SUMMER JAZZ FIRE</span><br/>
                        <span>FLAVA</span><br/>
                        <span>MADAME GALEN</span><br/>
                        <span>TARANTELLA</span><br/>
                        <br/>
                        <em>Wisteria brachybotris</em><br/>
                        <span>OKAYAMA</span><br/>
                        <span>SHIRO BENI</span><br/>
                        <br/>
                        <em>Wisteria floribunda</em><br/>
                        <span>BLACK DRAGON</span><br/>
                        <span>MACROBOTRYS</span><br/>
                        <span>PROLIFIC</span><br/>
                        <br/>
                        <br/>
                        <b>KRZEWY IGLASTE I BYLINY</b>  - wiele ciekawych gatunków i odmian<br/>
                    </div>
                </div>

            </div>
        </div>
    </div>


</template>

<script>

    import 'owl.carousel/dist/owl.carousel.js'
    import 'owl.carousel/dist/assets/owl.carousel.min.css'
    import 'owl.carousel/dist/assets/owl.theme.default.min.css'
    import '../../static/plugins/venobox/venobox.css'
    import '../../static/plugins/venobox/venobox.js'
    export default {
        components: {



        },
        methods: {

        },
        mounted: function () {


        }
    }



</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Asortyment.vue